import styled, { css } from 'styled-components'

export const Wrapper = styled.div<{ $arrowPosition: number }>`
  width: 100%;
  overflow: hidden;
  height: 580px;
`

export const SwiperWrapper = styled.div<{ $active: number; $slidesPerView: number }>`
  display: flex;
  align-items: center;
  position: relative;
  width: 100%;
  height: 100%;
  > * {
    flex-shrink: 0;
  }
`

export const SwiperSlider = styled.div<{ $slidesPerView: number }>`
  position: relative;
  width: calc(100% / ${({ $slidesPerView }) => $slidesPerView});
`

const arrow = css`
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 80px;
  height: 80px;
  border-radius: 50%;
  cursor: pointer;
  transition: background 300ms;
  z-index: 8;
  &:hover {
    background: #f3512b66;
  }
`

export const PrevArrow = styled.div<{ $arrowPosition: number }>`
  ${arrow}
  left: ${({ $arrowPosition }) => `${-$arrowPosition}px`};
  top: 50%;
  transform: translateY(-50%);
  padding-right: 8px;
`

export const NextArrow = styled.div<{ $arrowPosition: number }>`
  ${arrow}
  right: ${({ $arrowPosition }) => `${-$arrowPosition}px`};
  top: 50%;
  transform: translateY(-50%);
  padding-left: 8px;
`
